// test1002
(1002 && 0);
